/**
 * @description
 * Converts absolute temperature (kelvins beginning from absolute zero) to celsius
 *
 * @param {number} absoluteTemperature
 */
export const absoluteTemperatureToCelsius = (absoluteTemperature) => absoluteTemperature - 273.15;
